(function ($) {
  'use strict';
  this.LaVuelta2026 = function () {
    document.addEventListener('DOMContentLoaded', function () {
      if (window.dispatchEventType) {
        window.dispatchEventType(
          document,
          'SkodaAnalytics:Promotions:AddElements',
          undefined,
          undefined,
          undefined,
          {
            elements: document.querySelectorAll('#product-banner a'),
            context: 'La Vuelta 2026',
          }
        );
      }
    });
  };
}).bind(window)(jQuery);
